import { render } from "./DepositObjective.vue?vue&type=template&id=205a1149&scoped=true"
import script from "./DepositObjective.vue?vue&type=script&lang=js"
export * from "./DepositObjective.vue?vue&type=script&lang=js"

import "./DepositObjective.vue?vue&type=style&index=0&id=205a1149&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-205a1149"]])

export default __exports__